import React from 'react';
import type { IconProps } from '../types';

export const IconChart: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* Chart icon - candlestick chart */}
    <rect x="2" y="3" width="16" height="14" rx="1" stroke={color} strokeWidth="1.5"/>
    {/* Candlesticks */}
    <line x1="5" y1="6" x2="5" y2="14" stroke={color} strokeWidth="1" strokeLinecap="round"/>
    <rect x="4" y="8" width="2" height="4" fill={color} fillOpacity="0.6"/>

    <line x1="9" y1="5" x2="9" y2="13" stroke={color} strokeWidth="1" strokeLinecap="round"/>
    <rect x="8" y="7" width="2" height="3" fill={color} fillOpacity="0.8"/>

    <line x1="13" y1="7" x2="13" y2="15" stroke={color} strokeWidth="1" strokeLinecap="round"/>
    <rect x="12" y="9" width="2" height="5" fill={color} fillOpacity="0.5"/>
  </svg>
);
